import { Modals } from '../../types';
import { LoadingModal } from '../LoadingModal/LoadingModal';
import { UserConsent } from '../UserConsent/UserConsent';
import { BusinessFirstModal } from '../BusinessFirstModal/BusinessFirstModal';
import { ErrorModal } from '../ErrorModal/ErrorModal';
import React, { lazy, Suspense } from 'react';
import { useModalsAndWindow } from '../../context/ModalsAndWindowContext';
import { GoToOtherTabModal } from '../GoToOtherTabModal/GoToOtherTabModal';
import { useRenderControl } from '../../context/InstallerRenderControlContext';
import { InstallingLoader } from '../InstallLoader/InstallingLoader';
import { ModalWrapper } from './ModalWrapper';
const LazyConnectDomainModal = /*#__PURE__*/lazy(() => import('../ConnectDomain/ConnectDomain'));
const LazyUpgradeToPremiumModal = /*#__PURE__*/lazy(() => import('../UpgradeToPremium/UpgradeToPremium'));
const LazySiteSelectorModal = /*#__PURE__*/lazy(() => import('../SiteSelectorModal/SiteSelectorModal'));
const LazyDevSiteSelectorModal = /*#__PURE__*/lazy(() => import('../DevModeSiteSelector/DevModeSiteSelectorModal'));
const LazyIncompatibleAppErrorModal = /*#__PURE__*/lazy(() => import('../IncompatibleAppErrorModal/IncompatibleAppErrorModal'));
const LAZY_MODAL_MAPPING = {
  [Modals.siteSelector]: LazySiteSelectorModal,
  [Modals.connectDomain]: LazyConnectDomainModal,
  [Modals.upgradeToPremium]: LazyUpgradeToPremiumModal,
  [Modals.devModeSiteSelector]: LazyDevSiteSelectorModal,
  [Modals.incompatibleApp]: LazyIncompatibleAppErrorModal
};
const ACTIVE_MODAL_MAPPING = {
  [Modals.none]: () => /*#__PURE__*/React.createElement(React.Fragment, null),
  [Modals.error]: ErrorModal,
  [Modals.loading]: LoadingModal,
  [Modals.userConsent]: UserConsent,
  [Modals.businessFirst]: BusinessFirstModal,
  [Modals.goToOtherTab]: GoToOtherTabModal,
  [Modals.installingLoader]: InstallingLoader,
  ...LAZY_MODAL_MAPPING
};
const getIsLazyModal = activeModal => activeModal in LAZY_MODAL_MAPPING;
export const ModalRenderer = () => {
  const {
    isLoadingInstaller
  } = useRenderControl();
  const {
    activeModal
  } = useModalsAndWindow();
  const isLazyModal = getIsLazyModal(activeModal);
  const WrapperComponent = isLazyModal ? Suspense : ModalWrapper;
  const ActiveModal = ACTIVE_MODAL_MAPPING[activeModal];
  return /*#__PURE__*/React.createElement(WrapperComponent, {
    isOpen: activeModal !== Modals.none || isLoadingInstaller,
    fallback: /*#__PURE__*/React.createElement(React.Fragment, null)
  }, isLoadingInstaller && /*#__PURE__*/React.createElement(LoadingModal, null), /*#__PURE__*/React.createElement("div", {
    style: {
      display: isLoadingInstaller ? 'none' : 'unset'
    }
  }, /*#__PURE__*/React.createElement(ActiveModal, null)));
};
//# sourceMappingURL=ModalRenderer.js.map